<template lang="html">
  <a class="partnerLogo hover" :href="url" target="_blank">
    <figure class="partnerLogo__image">
      <img :src="logo" :alt="name">
    </figure>
    <!-- <h3 class="partnerLogo__name">{{ name }}</h3> -->
  </a>
</template>

<script>
export default {
  name: 'PartnerLogo',
  props: ['logo', 'name', 'url']
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.partnerLogo {
  &__name {
    font-family: CamptonBold;
    font-size: 16px;
    color: var(--Neu01);
    margin: 20px 0 5px;
  }

  &__image {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @include mq(0, 1024px) {
    &__name {
      margin: 10px 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PartnerLogo.vue